import React from 'react'
import './adminApp.css';
import Sidebar from './components/Sidebar';

export default function adminReports() {
    return (
        <>
            <div className="txt-container">
                <Sidebar />
                <div>
                    <h1>Admin Reports page</h1>
                </div>
            </div>
        </>
    )
}
